import I18n from 'I18n';
import { createSelector } from 'reselect';
import { makeMoment } from 'foundations-components/transitional/utils/SimpleDate';
import { FREQUENCY } from '../constants/AnalyticsConstants';
import { toSimpleDate } from '../utils/dateUtils';
const getAnalyzeState = state => state.analyze;
const getAnalyzeData = createSelector(getAnalyzeState, analyzeState => analyzeState.data);
export const getAnalyzeResponse = createSelector(getAnalyzeData, ({
  analyzeResponse
}) => analyzeResponse);
export const getAnalyzeParams = createSelector(getAnalyzeState, analyzeState => analyzeState.params);
const formatDateIntString = (dateInt, frequency) => {
  const date = makeMoment('portalTz', toSimpleDate(`${dateInt}`));
  if (frequency === FREQUENCY.MONTHLY) {
    return date.format('MM/YYYY');
  }
  const dateString = date.format('L');
  if (FREQUENCY.QUARTERLY === frequency) {
    return I18n.text(`analyze.frequency.prefix.${frequency}`, {
      date: dateString
    });
  }
  return dateString;
};
export const getPointsSummaryResult = createSelector(getAnalyzeResponse, ({
  pointsSummaryResult
}) => pointsSummaryResult.results || []);
export const getFrequency = createSelector(getAnalyzeParams, ({
  frequency
}) => frequency);
export const getView = createSelector(getAnalyzeParams, ({
  view
}) => view);
export const getPointsForViewsOverEvents = createSelector(getPointsSummaryResult, getFrequency, (plotPoints, frequency) => plotPoints.map(({
  dateInt,
  counters
}) => Object.assign({
  date: formatDateIntString(dateInt, frequency)
}, counters)));
export const getTotalsForEngagement = createSelector(getAnalyzeResponse, ({
  totals
}) => totals);